import type { ComponentProps } from 'react'
import PFASOptInForm from '../components/PFASOptInForm'

type Props = ComponentProps<typeof PFASOptInForm>

export default function Step1_OptInForm(props: Props) {
  return <PFASOptInForm {...props} />
}

